export default {"src":"/_next/static/media/error.0c9e22b6.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};